var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"renderer universes"},_vm._l((_vm.universes),function(universe,key){return (_vm.hasUniverse(key))?_c('span',{class:{active:_vm.hasRoleForUniverse(key)},attrs:{"title":_vm.getTooltipForUniverse(universe)}},[_c(universe.icon,{tag:"component",class:universe.class})],1):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384c4922","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/RendererUniverses.vue
// module id = null
// module chunks = 